<template>
  <div>
    <div v-if="Mobile">
      <el-badge :value="totalCount" class="item" slot="reference">
        <el-button type="warning" plain  icon="el-icon-shopping-cart-2" circle  @click="goCart"/>
      </el-badge>
    </div>
    <div v-else>
      <el-popover
        trigger="hover"
        popper-class="popper"
        >
        <el-table :data="cartProducts" size="mini" class="poptable">
          <el-table-column property="newpid" width="100" label="ID" />
          <el-table-column property="newlabel" width="170" label="商品" />
          <el-table-column property="price" width="60" label="单价" />
          <el-table-column property="times" width="50" label="时间" />
          <el-table-column property="iids" width="50" label="区域" />
          <el-table-column property="counts" width="70" label="总数" />
          <el-table-column property="prices" width="70" label="价格"   />
          <el-table-column label="操作">
            <template v-slot="scope">
              <el-button size="mini" @click="deleteFromCart(scope.row.newpid)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div>
          <p>共 {{ totalCount }} 个指标，{{ totalCounts }}个数据，总计 ¥&nbsp;{{ totalPrice }}</p>
          <el-button size="mini" type="danger" @click="goCart">去购物车</el-button>
        </div>
        <el-badge :value="totalCount" class="item" slot="reference">
          <el-button type="warning" plain  icon="el-icon-shopping-cart-2" circle  @click="goCart"/>
        </el-badge>
      </el-popover>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState,mapActions} from 'vuex';
import { deleteCart } from '@/api/cart';
export default {
  name: 'PopCart',
  computed:{
    ...mapState('cart', ['cartProducts']),
    ...mapGetters('cart', ['totalCount', 'totalCounts', 'totalPrice']),
    Mobile(){
      return this.$store.getters.isMobile
    },
  },
  methods:{
    ...mapActions('cart',['getFromCart']),
    async deleteFromCart(pid){
      await deleteCart(pid)
      this.getFromCart()
    },
    goCart(){
      this.$router.push({ name: 'cart' })
    }
  },
  mounted(){
    this.getFromCart()
  },
}
</script>
<style lang="scss">
.popper{
  max-height: 50%;
  width: 670px;
  overflow: auto;

  .poptable{
    max-height: 50%;
  }
}
</style>


// WEBPACK FOOTER //
// src/layout/components/NavBar/PopCart.vue